export default "__VITE_ASSET__DyUUWoxN__"